import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
           <a href="https://api.whatsapp.com/send?phone=918559018574" target="_blank">
  <button class="btn-floating whatsapp" fdprocessedid="c025xu">
    <img src="images/whatsapp.png" alt="WhatsApp" />
    <span>+91 8559018574</span>
          </button>
          <a href="tel:+918559018574 ">
  <button class="btn-floating phone" fdprocessedid="wgtey">
    <img src="images/call.png" alt="Phone" />
    <span>+918559018574</span>
  </button>
</a>
</a> 
        <p className="m-0 text-center">© 2024 copyright all right reserved</p>
    
        

      </div>
    </footer>
  );
}
